import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongQsypt = () => {

    const today = new Date();
    const currentYear = today.getFullYear();

    const [searchParams, setSearchParams] = useState({
        searchGrdc: '',
        searchLoca: '',
        searchYear: currentYear,
        searchCnt: '5',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value,
        };
        setSearchParams(newParams);
    };

    const dataHead = ['코드', '주증상', '합계', '(%)', '1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
    const dataColumn = ['TCODE', 'TNAME', 'TOT', 'TT0', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12'];
    const apiCall = '/ptmiapi/treatanalysis/bdtongqsypt_search.do';
    const apiCntCall = '';
    const searchParamsAdditional = {
        userAuth: localStorage.getItem("userAuth"),
        useremcd: localStorage.getItem("useremcd"),
    };
    const excelFileName = "다빈도 주증상";
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });
    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>기간</th>
                            <td>
                                <select id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>상위</th>
                            <td>
                                <select id="searchCnt"
                                    name="searchCnt"
                                    value={searchParams.searchCnt}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const value = (i + 1) * 5;
                                        return (
                                            <option key={value} value={value}>
                                                {value}%
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                rowspan={0}
            />
        </Main>
    )
}

export default BdTongQsypt;